import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Row, Col, Modal as antdModal } from 'antd';
import { Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION } from 'react-image-magnifiers';
import { GalleryContainer, MagnifierContainer, HeaderContainer } from './styled';
import './style.less';

export default class MediaGallery extends PureComponent {
  state = {
    selectedIndex: 0,
    lightboxIsOpen: false,
    preparedImages: {},
    displayedMedia: [],
  };

  UNSAFE_componentWillMount() {
    const { media } = this.props;
    const { displayedMedia } = this.state;

    if (!displayedMedia.length) {
      this.setDisplayedMedia(media);
    }
  }

  toggleLightbox = (selectedIndex) =>
    this.setState((state) => ({
      lightboxIsOpen: !state.lightboxIsOpen,
      selectedIndex,
    }));

  getImageOrientation = (imageSrc) => {
    const { preparedImages } = this.state;
    if (preparedImages[imageSrc]) return;

    let newImg = new Image();
    newImg.onload = () => {
      const { width, height } = newImg;
      preparedImages[imageSrc] = width >= height ? 'horizontal' : 'vertical';
      this.setState({ preparedImages });
      newImg = null;
    };
    newImg.src = imageSrc;
  };

  setDisplayedMedia = (_media) => this.setState({ displayedMedia: _media });

  render() {
    const { isLoading, media, showIcons, onDelete, canDelete, readOnly } = this.props;
    const { selectedIndex, lightboxIsOpen, preparedImages, displayedMedia } = this.state;
    const { confirm } = antdModal;

    if (!displayedMedia.length) {
      return null;
    }

    const renderIcon = () => {
      if (!showIcons) return false;
      return (
        <i className="icon">
          <svg
            viewBox="64 64 896 896"
            focusable="false"
            className=""
            data-icon="arrows-alt"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" />
          </svg>
        </i>
      );
    };

    const Close = ({ size = 20, ...props }) => (
      <svg size={size} {...props}>
        <path d="M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z" />
      </svg>
    );


    const handleDeletion = (currentMediaItem) => {
      confirm({
        title: 'Are you sure you want to delete this file?',
        zIndex: 9999,
        okText: 'Delete',
        okType: 'danger',
        icon: <LegacyIcon type="warning" />,
        autoFocusButton: null,
        onOk: () =>
          Promise.resolve(onDelete(currentMediaItem))
            .then(() => {
              this.setDisplayedMedia(displayedMedia.filter((_media) => _media.id !== currentMediaItem));
              document.querySelector('.react-images__container .close-btn')?.click();
              return Promise.resolve();
            })
            .catch((errors) => console.log('Deletion error', errors)),
        onCancel() {},
      });
    };

    const Header = ({ currentView, modalProps: { onClose } }) => {
      const currentMediaItem = currentView.id;

      return (
        <HeaderContainer>
          <Row>
            <Col span={2} xs={12}>
              {!readOnly ? (
                <button
                  type="submit"
                  className="delete-btn"
                  onClick={() => handleDeletion(currentMediaItem)}
                  disabled={!canDelete}
                >
                  Delete photo
                </button>
              ) : (
                ''
              )}
            </Col>
            <Col span={4} offset={18} xs={{ span: 12, offset: 0 }}>
              <button type="submit" onClick={onClose} className="close-btn">
                <Close />
                <span>Close Image</span>
              </button>
            </Col>
          </Row>
        </HeaderContainer>
      );
    };

    const View = ({ data: { src } }) => (
      <MagnifierContainer>
        <Magnifier
          style={{
            margin: 'auto',
            width: preparedImages[src] === 'horizontal' ? '55vw' : '25vw',
            height: preparedImages[src] === 'vertical' ? '80vh' : '75vh',
          }}
          imageSrc={src}
          imageAlt=""
          mouseActivation={MOUSE_ACTIVATION.SINGLE_CLICK}
          touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP}
        />
      </MagnifierContainer>
    );

    return (
      <GalleryContainer>
        {!isLoading ? (
          <div className="thumbs-container">
            {displayedMedia.map(({ src, thumb }, j) => {
              this.getImageOrientation(src);
              return (
                <span
                  className="thumb"
                  role="button"
                  key={src}
                  tabIndex="0"
                  onClick={() => this.toggleLightbox(j)}
                  onKeyDown={() => this.toggleLightbox(j)}
                  style={{ backgroundImage: `url(${thumb})` }}
                >
                  <div className="thumb-overlay" />
                  {renderIcon()}
                </span>
              );
            })}
          </div>
        ) : null}

        <ModalGateway>
          {lightboxIsOpen && !isLoading ? (
            <Modal onClose={this.toggleLightbox}>
              <Carousel
                currentIndex={selectedIndex}
                frameProps={{ autoSize: 'height' }}
                views={media}
                components={{ View, Header }}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </GalleryContainer>
    );
  }
}

MediaGallery.propTypes = {
  media: PropTypes.array,
  showIcons: PropTypes.bool,
  isLoading: PropTypes.bool,
  onDelete: PropTypes.func,
  canDelete: PropTypes.bool,
  readOnly: PropTypes.bool,
};

MediaGallery.defaultProps = {
  media: [],
  showIcons: true,
  isLoading: false,
  onDelete: null,
  canDelete: true,
  readOnly: false,
};

